export default function HeadingThreeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.9"
      height="14.18"
      viewBox="0 0 19.9 14.18"
    >
      <g transform="translate(-632.66 -163.003)">
        <path
          fill="currentColor"
          d="M13253.356-3491.6h1.7c.046.669.731 1.168 1.66 1.175 1.025 0 1.7-.6 1.688-1.428a1.462 1.462 0 00-1.647-1.4h-1.031v-1.424h.984a1.322 1.322 0 001.441-1.3 1.311 1.311 0 00-1.441-1.265 1.349 1.349 0 00-1.457 1.168h-1.714c.046-1.454 1.188-2.589 3.225-2.6 1.95-.007 3.171 1.025 3.194 2.433a2.139 2.139 0 01-1.724 2.14v.1a2.2 2.2 0 012.01 2.227c.021 1.77-1.607 2.8-3.534 2.8-2.122-.007-3.304-1.208-3.354-2.626zm-4.193 2.443v-6.41h-6.936v6.41h-1.887v-14h1.887v5.927h6.936v-5.927h1.887v14z"
          data-name="Union 36"
          transform="translate(-12607.681 3666.164)"
        ></path>
      </g>
    </svg>
  );
}
